import type { ReactNode } from 'react';

/** One sentence and one action. Never "Oops". */
export function EmptyState({
  icon,
  title,
  body,
  action,
}: {
  icon?: ReactNode;
  title: string;
  body?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-panel border border-dashed border-line px-6 py-12 text-center">
      {icon && <div className="text-ink-3 [&>svg]:size-8">{icon}</div>}
      <p className="font-medium">{title}</p>
      {body && <p className="max-w-md text-sm text-ink-2">{body}</p>}
      {action && <div className="mt-1">{action}</div>}
    </div>
  );
}
